/**
 * @typedef {{
 *   Email: string,
 *   FirstName: string,
 *   LastName: string,
 *   Company: string,
 *   Country: string,
 *   marketingConsent: string,
 *   URL: string,
 *   _mktoReferrer: string,
 *   formid: string,
 *   formVid: string,
 *   _mkt_trk: string,
 *   munchkinId: string,
 *   State: string,
 *   HQ_Country__c: string,
 *   HQ_State__c: string,
 *   Marketing_Channels__c: string,
 *   Email_Sends_per_Month_Range__c: string,
 *   demoRequestNotesImport: string,
 *   demoRequestEmailProvider: string,
 *   Phone: string,
 *   Email_Verification_Status__c: string,
 *   kickboxReason: string,
 *   Locale__c: string,
 *   Primary_Use_Case__c: string,
 * }} RoiGateFormData
 */

/**
 * @typedef {"SUBMISSION_SUBMIT_BUTTON_CLICK" | "SUBMISSION_VALIDATION_ERROR" | "SUBMISSION_SENT_TO_MARKETO"} GoogleSheetsLogType
 */

/**
 * @param roiGateFormData {RoiGateFormData}
 * @param logType {GoogleSheetsLogType}
 * @return {GoogleSheetFormData}
 */
module.exports = function convertRoiGateFormDataToGoogleSheetFormData(roiGateFormData, logType) {
    return {
        'JSON Payload': JSON.stringify(roiGateFormData, null, 2),
        Email: roiGateFormData["Email"],
        FirstName: roiGateFormData["FirstName"],
        LastName: roiGateFormData["LastName"],
        Company: roiGateFormData["Company"],
        Company_Size_Range__c: roiGateFormData["Company_Size_Range__c"],
        Country: roiGateFormData["Country"],
        State: roiGateFormData["State"],
        marketingConsent: roiGateFormData["marketingConsent"],
        URL: roiGateFormData["URL"],
        _mktoReferrer: roiGateFormData["_mktoReferrer"],
        formVid: roiGateFormData["formVid"],
        munchkinId: roiGateFormData["munchkinId"],
        _mkt_trk: roiGateFormData["_mkt_trk"],
        HQ_Country__c: roiGateFormData["HQ_Country__c"],
        HQ_State__c: roiGateFormData["HQ_State__c"],
        Marketing_Channels__c: roiGateFormData["Marketing_Channels__c"],
        Email_Sends_per_Month_Range__c: roiGateFormData["Email_Sends_per_Month_Range__c"],
        demoRequestNotesImport: roiGateFormData["demoRequestNotesImport"],
        demoRequestEmailProvider: roiGateFormData["demoRequestEmailProvider"],
        Phone: roiGateFormData["Phone"],
        Email_Verification_Status__c: roiGateFormData["Email_Verification_Status__c"],
        kickboxReason: roiGateFormData["kickboxReason"],
        Locale__c: roiGateFormData["Locale__c"],
        Primary_Use_Case__c: roiGateFormData["Primary_Use_Case__c"],
        formid: roiGateFormData["formid"],
        LOG_TYPE: logType,
    };
}